<template>
  <div>
    <modal
      name="security-code"
      width="92%"
      height="auto"
      :maxWidth="480"
      :adaptive="true"
      @opened="modalOpened()"
      @closed="modalClosed()"
      class="popupModal"
    >
      <div class="flex flex-col min-h-full p-4">
        <div class="flex flex-col flex-grow">
          <p class="text-gray-500 text-xs regular text-center">
            <strong>{{ lang["please_enter_security_code"][language] }}</strong>
          </p>
          <div class="mb-4">
            <label
              class="block text-gray-700 text-sm font-bold mb-2"
              for="name"
              >{{ lang["security_code"][language] }}</label
            >
            <input
              autocomplete="false"
              aria-autocomplete="false"
              v-model="securityCode"
              name="security-code"
              class="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
              id="security-code"
              type="text"
              :placeholder="lang['security_code'][language]"
              @keyup.enter="initiatePayment(selectedPaymentType)"
            />
            <span
              :class="[
                isSecurityCodeValidated ? 'text-green-500' : 'text-red-500',
              ]"
              >{{ securityCodeValidationMessage }}</span
            >
          </div>
          <div>
            <button
              :disabled="!isSecurityCodeValidated"
              @click="initiatePayment(selectedPaymentType)"
              :class="[
                isSecurityCodeValidated ? 'bg-blue-500' : 'bg-gray-400',
                'text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline inline-flex items-center',
              ]"
              type="button"
            >
              <svg
                v-if="isSubmitting"
                style="animation: spin-animation 0.5s infinite"
                class="fill-current inline-block h-4 w-4"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
              >
                <path
                  class="heroicon-ui"
                  d="M6 18.7V21a1 1 0 0 1-2 0v-5a1 1 0 0 1 1-1h5a1 1 0 1 1 0 2H7.1A7 7 0 0 0 19 12a1 1 0 1 1 2 0 9 9 0 0 1-15 6.7zM18 5.3V3a1 1 0 0 1 2 0v5a1 1 0 0 1-1 1h-5a1 1 0 0 1 0-2h2.9A7 7 0 0 0 5 12a1 1 0 1 1-2 0 9 9 0 0 1 15-6.7z"
                />
              </svg>
              <span>{{ lang["submit"][language] }}</span>
            </button>
            <button
              @click="$modal.hide('security-code')"
              class="bg-gray-500 hover:bg-gray-700 ml-2 text-black font-bold py-2 px-2 rounded focus:outline-none focus:shadow-outline inline-flex items-center"
              type="button"
            >
              <span>{{ lang["cancel"][language] }}</span>
            </button>
          </div>
        </div>
      </div>
    </modal>
    <modal
      name="failedPayment"
      width="92%"
      height="auto"
      :maxWidth="480"
      :adaptive="true"
      class="text-center popupModal"
    >
      <p class="mt-6">{{ lang["error"][language] }}</p>
      <button
        @click="
          $router.go({ name: `Home` });
          $modal.hide('failedPayment');
        "
      >
        <p class="bg-new-primary text-white px-4 py-1 rounded-xl mt-4 mb-4">
          {{ lang["reload_page"][language] }}
        </p>
      </button>
    </modal>
    <div v-if="availablePaymentTypes.length" class="w-full mx-auto" :style="paymentTextColor">
      <div class="absolute inset-x-0 mx-auto -mt-1" v-if="loadingStatus">
        <clip-loader
          class="mt-10"
          :loading="loadingStatus"
          color="#404040"
        ></clip-loader>
      </div>
      <div :class="['flex justify-center mx-auto', hasKiosk ? 'w-2/3' : '']">
        <div
          v-if="totalPriceValueWithCosts > 0"
          :class="[
            'w-full flex flex-col items-center pb-10',
            loadingStatus && 'opacity-50',
          ]"
        >
          <button
            v-for="paymentType in availablePaymentTypes"
            :key="paymentType.Id"
            @click="loadingStatus ? '' : initiatePayment(paymentType)"
            :class="[
              'flex justify-between px-10 py-4 w-full  border-b-2 transition duration-500 b',
              paymentType.name_en == 'Payconiq' && paymentType.has_priority
                ? 'bg-payconiq'
                : '',
            ]"
            :style="loadingStatus ? paymentLoadingBackground : ''"
          >
            <div class="flex items-center">
              <!-- <img
                v-if="paymentType.Id == 1 && paymentType.has_priority"
                class="h-8 rounded-md object-contain mr-2"
                :src="require('../assets/images/payconiq-logo.png')"
                alt="Logo"
              /> -->
              <img
                :src="paymentMethodIcon(paymentType['Id'])"
                class="w-6 h-6 object-contain mr-4"
              />
              <span
                :style="
                  paymentType.name_en == 'Payconiq' && paymentType.has_priority
                    ? 'titleMain'
                    : ''
                "
                :class="[
                  'flex',
                  paymentType.name_en == 'Payconiq' && paymentType.has_priority
                    ? 'text-white'
                    : '',
                ]"
              >
                {{ paymentType[`name_${language}`] }}</span
              >
            </div>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 320 512"
              class="w-6 h-6 bg-primary-100 rounded-full"
            >
              <path
                d="M242.6 280.3l-103.9 82.2c-5 4-13.1 4-18.2
              0l-12.1-9.6c-5-4-5-10.4 0-14.3l82.4-65.5-82.4-65.5c-5-4-5-10.4
              0-14.3l12.1-9.6c5-4 13.1-4 18.2 0l103.9 82.2c5 4 5 10.4 0 14.4z"
                fill="#666666"
              />
            </svg>
          </button>
          <button
            v-if="comoMemberCode"  
            :class="[
              'flex justify-between px-10 py-4 w-full transition duration-500 b',
            ]"
            :style="loadingStatus ? paymentLoadingBackground : ''"
          >
            <div class="flex flex-col w-full items-start">
              <div
                class="flex w-full items-center justify-between"
              >
                <p v-if="member.pointsBalance.usedByPayment">Points Balance</p>
                <p v-if="member.creditBalance.usedByPayment">Credit Balance</p>
                <p class="text-2xl">{{ loyaltyPoints/100 }}</p>
              </div>
              <div class="flex w-full items-center  justify-between">
                <p>Cart Total</p>
                <p class="text-2xl">{{ totalPriceValueWithCostsValue }}</p>
              </div>
              <div :class="['flex flex-col w-full  transition-all duration-300',
                redeemLoyaltyPoints == true ? 'h-full opacity-100' : 'h-0 opacity-0']">
                <div class="flex items-center justify-between">
                  <p class="text-gray-500">Loyalty Discount</p>
                  <p class="text-green-400">-{{ loyaltyDiscount }}</p>
                </div>
                <div class="flex items-center justify-between">
                  <p class="text-2xl">Total</p>
                  <p class="text-3xl">{{ totalPriceValueWithLoyaltyDiscount }}</p>
                </div>
              </div>
            </div>
          </button>
          <div 
            v-if="comoMemberCode"
            class="px-10 w-full transition duration-500 z-10">
            <div class="flex justify-end w-full">
              <button 
              v-if="!redeemLoyaltyPoints && loyaltyPoints != 0"
              :class="['py-4 px-8 bg-green-300']"
                @click="redeemComoPoints">
                Redeem
              </button>
            </div>
            <div class="flex justify-between w-full">
              <button 
              v-if="redeemLoyaltyPoints"
              :class="['py-4 px-8 bg-red-300']"
                @click="cancelComoPoints">
                Cancel
              </button>
              <button 
              v-if="redeemLoyaltyPoints && totalPriceValueWithLoyaltyDiscount == 0"
              :class="['py-4 px-8 bg-green-300']"
                @click="initiateComoPayment">
                Proceed
              </button>
              <button 
              v-if="redeemLoyaltyPoints && totalPriceValueWithLoyaltyDiscount != 0"
              :class="['py-4 px-8 bg-green-300']"
              >
                Select Payment Method
              </button>
            </div>
          </div>
        </div>
        <div class="pb-20" v-else>
          {{ lang["redirecting_payment"][language] }}
        </div>
      </div>
    </div>
    <div v-else class="w-full mx-auto">
      <h1 class="p-8 text-center text-lg text-gray-600">
        {{ lang["no_payment_method_found"][language] }}
      </h1>
    </div>
    <modal
      name="tryPaymentAgain"
      class="retry"
      width="92%"
      height="auto"
      :maxWidth="480"
      :adaptive="true"
    >
      <p class="text-center mt-2">
        {{ lang["something_went_wrong"][language] }}
      </p>
      <div class="flex justify-center">
        <button
          :style="makeStyles(hasKiosk&&mainButtonRadius, btnMainBackground , btnMainText)"
          class="rounded-full px-4 py-1 mt-4 text-white mb-2"
          @click="closeRetryModal"
        >
          Close
        </button>
      </div>
    </modal>
    <modal
      name="QR-payment"
      width="92%"
      class="qrCodeModal"
      height="auto"
      @before-close="closingModal"
      :maxWidth="480"
      :adaptive="true"
      :clickToClose="false"
    >
      <div class="flex justify-center flex-col">
        <div class="flex flex-col">
          <h2 class="text-2xl text-center mt-1 font-bold">
            {{ lang["scan_qr_code"][language] }}
          </h2>
          <img :src="`${qrCodeImage}`" />
        </div>
        <button
          @click="createNewOrder()"
          type="button"
          :class="[
            ' text-sm mb-4 -mt-4 p-4 flex just mx-auto py-2 font-semibold transition duration-300 rounded-large border bg-new-primary text-white',
          ]"
          :style="makeStyles(hasKiosk && mainButtonRadius , btnMainBackground , btnMainText)"
        >
          {{ lang["create_new_order"][language] }}
        </button>
      </div>
    </modal>
    <CcvModal
      v-if="launchCcvModal"
      @initiated="handleCcvInitiation"
      @cancelled="handleCcvCancellation"
      @pending="handleCcvPending"
    />
  </div>
</template>
<script>
import lang from "../lang";
import { mapGetters } from "vuex";
import sha256 from "js-sha256";
const ClipLoader = require("vue-spinner/src/ClipLoader.vue").default;
import axios from "axios";
import CcvModal from "../components/CcvModal.vue";

import {
  paymentMethodIcon,
  // saveNewSessionId
} from "../utils";

export default {
  data() {
    return {
      lang: lang,
      isSubmitting: false,
      isPaymentInitiated: false,
      securityCodeValidationMessage: "",
      isSecurityCodeValidated: false,
      selectedPaymentType: {},
      loadingStatus: false,
      launchCcvModal: false,
      qrCodeId: null,
      qrCodeTimer: "",
      comoMemberCode: sessionStorage.getItem('comoMemberCode')
    };
  },
  components: {
    ClipLoader,
    CcvModal,
  },
  computed: {
    ...mapGetters([
      "menu",
      "theme",
      "menuHash",
      "language",
      "orderingSecurityCodeHash",
      "customer",
      "paidFreeItem",
      "hasKiosk",
      "sessionId",
      "member",
      "loyaltyPoints"
    ]),
    ...mapGetters("Cart", [
      "cartItems",
      "availablePaymentTypes",
      "tableId",
      "customer",
      "tableManual",
      "tables",
      "totalPriceValueWithCosts",
      "totalPriceValueWithCostsValue",
      "totalPriceValueWithLoyaltyDiscount",
      "qrCodeImage",
      "totalPriceValue",
      "redeemLoyaltyPoints",
      "loyaltyDiscount"
    ]),
    ...mapGetters("Theme", [
      "titleMain",
      "paymentLoadingBackground",
      "paymentBtnBackground",
      "mainButtonRadius",
      "btnDestructiveIcon",
      "btnMainBackground",
      "mainButtonRadius",
      "btnMainText",
      "paymentTextColor",
    ]),
    securityCode: {
      get() {
        return this.$store.getters["Cart/securityCode"];
      },
      set(value) {
        if (!value) {
          this.securityCodeValidationMessage = "";
        }
        if (sha256(value).toUpperCase() == this.orderingSecurityCodeHash) {
          this.securityCodeValidationMessage =
            this.lang["valid_security_code"][this.language];
          this.isSecurityCodeValidated = true;
        } else {
          this.securityCodeValidationMessage =
            this.lang["invalid_security_code"][this.language];
          this.isSecurityCodeValidated = false;
        }
        this.$store.commit("Cart/updateSecurityCode", value);
      },
    },
  },
  methods: {
    createNewOrder() {
      this.$store.commit("Cart/removeOrderChunks");
      // saveNewSessionId("Payment > createNewOrder:317");
      this.$store.dispatch('CREATE_NEW_SESSION_ID')
      if (this.menu.pos_mode == "take-out" && !this.hasKiosk) {
        location.href = `/${this.menuHash}`;
      } else if (this.hasKiosk) {
        if (this.$route.query.printerIp) {
          location.href = `/${this.menuHash}/start/kiosk?mode=kiosk&printerIp=${this.$route.query.printerIp}`;
        } else {
          location.href = `/${this.menuHash}/start/kiosk?mode=kiosk`;
        }
      } else {
        location.href = `/${this.menuHash}/${
          this.stickerId
        }`;
      }
    },
    // when closing the qr code modal we need to reset the values and stop the interval
    closingModal() {
      this.$store.commit("Cart/updateQrCodeImage", null);
      this.qrCodeId = 0;
      clearInterval(this.qrCodeTimer);
    },
    closeRetryModal() {
      this.$modal.hide("tryPaymentAgain");
    },
    initiateComoPayment() {
      this.$store.dispatch("COMO_PAYMENT").then(() => {
        this.$store.commit("updateComoPayment", true);
        if (this.totalPriceValueWithCosts == 0) {
          this.initiatePayment(12);
        }
        });
    },
    redeemComoPoints() {
      this.$store.commit("Cart/updateRedeemLoyaltyPoints", true);
    },
    cancelComoPoints() {
      this.$store.commit("Cart/updateRedeemLoyaltyPoints", false);
    },
    initiatePayment(paymentType) {
      if (paymentType.Id == 10) {
        this.qrCodeId = 10;
      } else {
        this.qrCodeId = null;
      }
      if (this.paidFreeItem == false) {
        // Checks if the item is free
        if (this.totalPriceValueWithCosts == 0) {
          this.$store.commit("updatePaidFreeItem", true);
          this.$store.commit("Cart/updatePaymentTypeId", paymentType);
        } else {
          this.$store.commit("Cart/updatePaymentTypeId", paymentType.Id);
        }

        // updates the stickerId if it is table-manual
        if (this.menu.pos_mode == "table-manual") {
          localStorage.setItem("stickerId", this.tableManual);
        }
        (this.loadingStatus = true), (this.selectedPaymentType = paymentType);

        // Pay in restaurant and check the security code
        if (
          paymentType.Label == "POS" &&
          this.orderingSecurityCodeHash != sha256("").toUpperCase() &&
          !this.isSecurityCodeValidated
        ) {
          this.$modal.show("security-code");
          this.loadingStatus = false;
          return;
        }
        this.$modal.hide("security-code");

        // this.$store.commit("startPageLoading");
        this.isPaymentInitiated = true;

        // if payment is ccv than open the ccv modal else update the order and initiate the transaction
        if (paymentType.Id === 8) {
          this.launchCcvModal = true;
        } else {
          if (this.menu.pos_mode == "table-manual") {
            this.$store.dispatch("Cart/UPDATE_ORDER").then(() => {
              if (this.totalPriceValueWithCosts == 0) {
                this.$store
                  .dispatch("Cart/INITIATE_TRANSACTION", paymentType)
                  .then((response) => {
                    this.loadingStatus = false;
                    location.href = response.data.paymentUrl;
                  });
              } else {
                this.$store
                  .dispatch("Cart/INITIATE_TRANSACTION", paymentType.Id)
                  .then((response) => {
                    this.loadingStatus = false;
                    location.href = response.data.paymentUrl;
                    this.$store.commit("updateEndOrder", true);
                  })
                  .catch(() => {
                    console.log("updateEndOrder BUG", 1);
                  });
              }
            });
          }
          if (this.menu.pos_mode == "table" && this.tableId != "") {
            let tableNumber = JSON.stringify(this.tables.length);
            let tableFalse = 0;
            this.$store.commit("updatePaidFreeItem", true);
            this.tables.map((x) => {
              if (JSON.stringify(x.Id) == this.tableId) {
                this.$store.dispatch("Cart/UPDATE_ORDER").then(() => {
                  if (this.totalPriceValueWithCosts == 0) {
                    this.$store
                      .dispatch("Cart/INITIATE_TRANSACTION", paymentType)
                      .then((response) => {
                        this.loadingStatus = false;
                        location.href = response.data.paymentUrl;
                        this.$store.commit("updateEndOrder", true);
                      })
                      .catch(() => {
                        console.log("updateEndOrder BUG", 1);
                        this.loadingStatus = false;
                        this.$modal.show("tryPaymentAgain");
                      });
                  } else {
                    this.$store
                      .dispatch("Cart/INITIATE_TRANSACTION", paymentType.Id)
                      .then((response) => {
                        this.loadingStatus = false;
                        location.href = response.data.paymentUrl;
                        this.$store.commit("updateEndOrder", true);
                      })
                      .catch(() => {
                        console.log("updateEndOrder BUG", 1);
                        this.loadingStatus = false;
                        this.$modal.show("tryPaymentAgain");
                      });
                  }
                });
              } else {
                tableFalse++;
              }
              if (tableNumber == tableFalse) {
                if (
                  this.menu.pos_mode != "take-out" &&
                  this.menu.pos_mode != "table-manual"
                ) {
                  this.loadingStatus = false;
                  this.$modal.show("failedPayment");
                  let arr = [];
                  arr.push("no tableid found");
                  arr.push(this.menu);
                  arr.push(this.customer);
                  arr.push("tableid", this.tableId);
                  arr.push("browser", this.$browserDetect.meta.name);
                  arr.push("ios", this.$browserDetect.isIOS);
                  arr.push("version", this.$browserDetect.meta.version);
                  let data = {
                    MenuHash: this.menuHash,
                    Dump: JSON.stringify(arr),
                  };
                  axios
                    .post(
                      `${process.env.VUE_APP_API_BASE_PATH}/PostErrorDump`,
                      data
                    )
                    .then(() => {});
                }
              }
            });
          } else {
            if (
              this.menu.pos_mode != "take-out" &&
              this.menu.pos_mode != "table-manual"
            ) {
              this.loadingStatus = false;
              this.$modal.show("failedPayment");
              let arr = [];
              arr.push(this.menu);
              arr.push(this.customer);
              arr.push("tableid", this.tableId);
              arr.push("browser", this.$browserDetect.meta.name);
              arr.push("ios", this.$browserDetect.isIOS);
              arr.push("version", this.$browserDetect.meta.version);
              let data = {
                MenuHash: this.menuHash,
                Dump: JSON.stringify(arr),
              };
              axios
                .post(
                  `${process.env.VUE_APP_API_BASE_PATH}/PostErrorDump`,
                  data
                )
                .then(() => {
                  console.log(this.menu.pos_mode);
                  console.log(this.tableId);
                });
            }
          }
          if (
            this.menu.pos_mode == "take-out" && 
            (this.menu.is_checkout_name_enabled ? this.customer.fullName != "" : true)
          ) {
            this.$store.dispatch("Cart/UPDATE_ORDER").then(() => {
              if (this.totalPriceValueWithCosts == 0) {
                this.$store
                  .dispatch("Cart/INITIATE_TRANSACTION", paymentType)
                  .then((response) => {
                    this.loadingStatus = false;
                    location.href = response.data.paymentUrl;
                  })
                  .catch(() => {
                    this.loadingStatus = false;
                    this.$modal.show("tryPaymentAgain");
                  });
              } else {
                this.$store
                  .dispatch("Cart/INITIATE_TRANSACTION", paymentType.Id)
                  .then((response) => {
                    this.loadingStatus = false;
                    location.href = response.data.paymentUrl;
                  })
                  .catch(() => {
                    this.loadingStatus = false;
                    this.$modal.show("tryPaymentAgain");
                  });
              }
            });
          } else {
            if (
              this.menu.pos_mode != "table" &&
              this.menu.pos_mode != "table-manual"
            ) {
              this.loadingStatus = false;
              this.$modal.show("failedPayment");
              let arr = [];
              arr.push(this.menu);
              arr.push(this.customer);
              arr.push("browser", this.$browserDetect.meta.name);
              arr.push("ios", this.$browserDetect.isIOS);
              arr.push("version", this.$browserDetect.meta.version);
              let data = {
                MenuHash: this.menuHash,
                Dump: JSON.stringify(arr),
              };
              axios
                .post(
                  `${process.env.VUE_APP_API_BASE_PATH}/PostErrorDump`,
                  data
                )
                .then(() => {
                  console.log(this.customer);
                });
            }
          }
        }
      }
    },
    modalOpened() {
      document.getElementById("security-code").focus();
    },
    modalClosed() {
      this.isSecurityCodeValidated = false;
      this.$store.commit("Cart/updateSecurityCode", "");
    },
    // handle CCV methods
    handleCcvInitiation() {
      this.loadingStatus = false;
      //   this.$modal.hide("retry-payment");
    },
    handleCcvCancellation() {
      this.$modal.show("tryPaymentAgain");
      this.launchCcvModal = false;
      this.loadingStatus = false;
    },
    handleCcvCompletion(data) {
      this.loadingStatus = false;
      location.href = data.orderDetailsUrl;
      this.$router.replace(data.orderDetailsUrl);
      this.$modal.hide("cart-items");
    },
    handleCcvPending(data) {
      this.loadingStatus = false;
      location.href = data.orderDetailsUrl;
      this.$router.replace(data.orderDetailsUrl);
      this.$modal.hide("cart-items");
    },
    paymentMethodIcon(paymentId) {
      return paymentMethodIcon(paymentId);
    },

    /**
     * Automatically initiate payment if only a single paymentmethod is available
     */
    checkPaymentMethodsAmount() {
      // check length
      const amount = this.availablePaymentTypes.length;

      // get first method and init payment
      if (amount === 1) {
        this.loadingStatus = false;
        this.initiatePayment(this.availablePaymentTypes[0]);
      }
    },
  },
  mounted() {
     /** This is a temporaray solution to fix the header disappearing issue */
    // this.$nextTick(() => {
    //   let modelCart = document.getElementById('modalCart')
    //   modelCart.style.scrollMargin = '100px'
    //   modelCart.scrollIntoView()
    // })   
    
    // if total price is 0 than we redirect them automaticly to 'pay in restaurant' (id = 4)
    if (this.totalPriceValueWithCosts == 0) {
      for (let i = 0; i < this.availablePaymentTypes.length; i++) {
        this.loadingStatus = true;
        this.initiatePayment(4);
      }
    }
    if (this.availablePaymentTypes.length == 1 && this.hasKiosk) {
      this.loadingStatus = true;
      this.initiatePayment(this.availablePaymentTypes[0]);
      console.log(this.availablePaymentTypes[0].Id);
    }
    if (!this.cartItems.length) {
      if (this.menu.name_nl == "TAKE-AWAY") {
        this.$router.push(`/${this.$route.params.menuHash}`).catch(() => {});
      } else {
        if (!this.menuHash || this.tableId == 0 || this.tableId == "") {
          if (this.stickerId !== 0) {
            this.$router
              .push(
                `/${this.$route.params.menuHash}/` +
                  this.stickerId
              )
              .catch(() => {});
          } else {
            this.$router
              .push(`/${this.$route.params.menuHash}`)
              .catch(() => {});
          }
        }
      }
    }
  },
  updated() {
    // checks if we have a qrCodeImage and if paymentId is 10 (id:10 = pay with qr code)
    if (this.qrCodeImage && this.qrCodeId == 10) {
      // shows the QR code modal
      this.$modal.show("QR-payment");
      // calls the function every 1,5 sec untill we have another status than paymentpending
      let self = this;
      // always clears the interval first
      clearInterval(this.qrCodeTimer);
      // calls the interval
      this.qrCodeTimer = setInterval(function () {
        axios
          .get(
            `${process.env.VUE_APP_API_BASE_PATH}/GetOrder?menuHash=${self.menuHash}&sessionId=${self.sessionId}`
          )
          .then((resp) => {
            if (resp.data.orderStatus != "PaymentPending") {
              // get the tableId (same function from cart.js in INITIATE_TRANSACTION)
              // redirect to the correct order detail page
              location.href = `/${self.menuHash}/${self.stickerId}/order-details?sessionId=${self.sessionId}`;
              // clear the interval
              clearInterval(this.qrCodeTimer);
            }
          });
      }, 1500);
    }
  },
  created() {},
};
</script>

<style scoped>
button:focus {
  outline: 0;
  outline-color: transparent;
  outline-style: none;
}
</style>
